/*
* Конвертация «Date ↔ ГГГГ-ММ-ДД» для нативного input[type=date]. Через toISOString
* делать нельзя: он приводит к UTC, и вечером московского дня поле показывало бы
* вчерашнее число. Собираем из локальных компонент — поле и так про календарный день.
* */
const pad = (value: number): string => String(value).padStart(2, "0");

export const dateToInputValue = (date: Date): string =>
    `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

/*
* Пустое или недописанное значение — null: пока пользователь набирает год, поле отдаёт
* строки вроде "0002-01-01", и подставлять их в форму как валидную дату нельзя.
* Возвращаем начало локального дня; конец периода фича доводит до 23:59:59 сама.
* */
export const inputValueToDate = (value: string): Date | null => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);

    if (!match) return null;

    const year = Number(match[1]);
    const month = Number(match[2]);
    const day = Number(match[3]);

    if (year < 1000 || month < 1 || month > 12 || day < 1 || day > 31) return null;

    const date = new Date(year, month - 1, day);

    // Отсекаем «31 февраля»: Date переносит такую дату на следующий месяц.
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) {
        return null;
    }

    return date;
};

export const startOfDay = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);

// Выбранный день входит в период включительно — иначе последний день срока действия промокода
// оказывается нерабочим, а последний день фильтра по дате — пустым.
export const endOfDay = (date: Date): Date =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59, 999);
